import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarParametrosLogin(api) { 
    let parametros = {
      operacao: 'buscarParametrosLogin'
    }
    let retorno = {};
    
    await api.santriGET('/rest/parametro', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RParametro.js